import { Component, OnDestroy, OnInit } from '@angular/core';
import { DocumentsHttpService } from 'src/app/services/httpServices/documentsHttpService/documents-http.service';
import { HttpErrorHandlerService } from 'src/app/services/httpServices/httpErrorHandlerService/http-error-handler.service';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let Redoc: any;

@Component({
  selector: 'app-api',
  templateUrl: './api.component.html',
  styleUrls: ['./api.component.scss'],
})
export class ApiComponent implements OnInit, OnDestroy {
  private readonly MAX_RETRY_ATTEMPTS = 50; // 5 seconds max (50 * 100ms)
  private retryCount = 0;
  private retryTimeout?: ReturnType<typeof setTimeout>;

  constructor(
    private readonly _documentsHttpService: DocumentsHttpService,
    private readonly _httpErrorHandlerService: HttpErrorHandlerService
  ) {}

  ngOnInit(): void {
    this._documentsHttpService.getOpenApiSchema().subscribe(
      (data) => {
        this.initRedoc(data);
      },
      (error) => this._httpErrorHandlerService.handle(error)
    );
  }

  ngOnDestroy(): void {
    if (this.retryTimeout) {
      clearTimeout(this.retryTimeout);
    }
  }

  private initRedoc(data: object): void {
    if (typeof Redoc !== 'undefined') {
      Redoc.init(
        data,
        {
          hideDownloadButton: true,
          noAutoAuth: true,
          sortPropsAlphabetically: true,
          theme: {
            logo: {
              gutter: '10% 30%',
            },
          },
        },
        document.getElementById('redoc')
      );
    } else if (this.retryCount < this.MAX_RETRY_ATTEMPTS) {
      // Retry after a short delay if Redoc is not loaded yet
      this.retryCount++;
      this.retryTimeout = setTimeout(() => this.initRedoc(data), 100);
    } else {
      console.error('Redoc failed to load after maximum retry attempts');
    }
  }
}
